import { render, staticRenderFns } from "./onHefcTmp.vue?vue&type=template&id=1dc2c9ae"
import script from "./onHefcTmp.vue?vue&type=script&lang=js"
export * from "./onHefcTmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports